import { render, staticRenderFns } from "./leadsDashboardAllLeads.vue?vue&type=template&id=42771848&scoped=true"
import script from "./leadsDashboardAllLeads.vue?vue&type=script&lang=js"
export * from "./leadsDashboardAllLeads.vue?vue&type=script&lang=js"
import style0 from "./leadsDashboardAllLeads.vue?vue&type=style&index=0&id=42771848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42771848",
  null
  
)

export default component.exports